module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.labelNewLine) ? _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "1px 0px 1px 0px"
    }
  }, [(_vm.showLabel && _vm.hideAll == false) ? _c('label', {
    staticClass: "col-xs-2 control-label esma_form_label",
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.labelNewLine) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.showLabel && _vm.labelNewLine == false && _vm.hideAll == false) ? _c('label', {
    class: {
      'col-xs-2': _vm.showLabelAs4 == false, 'col-xs-4': _vm.showLabelAs4, 'control-label': true, 'esma_form_label': true, 'esma_error_field': _vm.showAsError
    },
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + " "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideAll == false),
      expression: "hideAll == false"
    }],
    ref: "local_value",
    staticClass: "form-control",
    style: (_vm.filedStyle),
    attrs: {
      "disabled": this.localRefreshSequecnce > 0 && _vm.isDisabled && _vm.forcewrite == false,
      "id": _vm.fieldID,
      "name": _vm.fieldID,
      "placeholder": "",
      "rows": _vm.fieldRows
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideAll == false),
      expression: "hideAll == false"
    }],
    staticStyle: {
      "font-size": "15px",
      "font-weight": "800",
      "letter-spacing": "1px",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.fieldMessage))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51f99387","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/text-area.vue
// module id = 985
// module chunks = 0